export default __webpack_public_path__ + "static/media/Nutricion-header-image.1cc707f9.jpg";